<template lang="html">
  <div class="pull-new-block" @click="receive">
    <div class="pull-new-block-img">
      <img src="../../assets/images/placeholder.png" :data-src="course.image" alt="" ref="img">
    </div>
    <div class="pull-new-block-ctx">
      <h5 class="pull-new-block-ctx-title">
        {{course.title}}
      </h5>
      <p class="pull-new-block-ctx-desc">
        {{course.description}}
      </p>
      <div class="pull-new-block-ctx-m">
        <span>{{courseTime}}分钟 | {{courseType}}</span>
        <span>￥{{course.price}}</span>
      </div>
      <div class="pull-new-block-ctx-m pull-new-block-ctx-info">
        <span>{{course.receiveUserCount}}人已领取</span>
        <template v-if="course.isBuy">
          <span class="pull-new-block-btn">
            立即学习
          </span>
        </template>
        <template v-else>
          <div>
            <span v-if="!course.isReceive && !isReceive" class="pull-new-block-btn" >
              免费领取
            </span>
            <span v-if="course.isReceive && isReceive" class="pull-new-block-btn received">
              已领取
            </span>
            <span v-if="!course.isReceive && isReceive" class="pull-new-block-btn received">
              免费领取
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PullNewBlock',
  props: ['course', 'isReceive'],
  computed : {
    courseTime () {
      return parseInt(this.course.seconds/60)
    },
    courseType () {
      switch (this.course.type) {
        case 1:
          return '视频课'
          break
        case 2: 
          return '音频课'
          break
        default:
          return '视频+音频'
          break;
      }
    },
    domImg () {
      return this.$refs.img
    }
  },
  data() {
    return {
      bubbleShow: false,
      blockTimer: ''
    }
  },
  methods: {
    receive () {
      if (this.course.isBuy) {
        this.$router.push({
          path: '/sign-up',
          query: { courseId: this.course.courseId }
        })
      }
      if (!this.course.isReceive && !this.isReceive) {
        this.$emit('receive', this.course)
      }
      // if (!this.course.isBuy && !this.isReceive) {
      //   this.$emit('receive', this.course)
      // } else {
      //   this.$router.push({
      //     path: '/sign-up',
      //     query: { courseId: this.course.courseId }
      //   })
      // }
    },
    init () {
      let imgSrc = this.domImg.getAttribute('data-src')
      this.blockTimer = setTimeout(() => {
        if (imgSrc) {
          this.domImg.src = imgSrc
        }
      }, 500)
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearTimeout(this.blockTimer)
  },
  components: {
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.pull-new-block {
  width: rem(710);
  height: rem(210);
  padding: rem(21);  
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: rem(10);
  margin: auto;
  margin-bottom:rem(28);
  &-btn {
    display: inline-block;
    background-color: #FFB500;
    height: rem(40);
    width: rem(126);
    line-height: rem(40);
    text-align: center;
    box-sizing: border-box;
    background-image: linear-gradient(to right, #FFB500, #F48F00);
    color: #fff;
    border-radius: rem(6);
    text-decoration: none!important;
  }
  .received {
    background: #CBD4DD;
  }
  &::after {
    content: '';
    display: block;
    clear: both;
  }
  &-img {
    float: left;
    width: rem(260);
    margin-right: rem(22);
    > img {
      width: 100%;
      border-radius: rem(8);
      height: rem(164);
    }
  }
  &-ctx {
    float: left;
    width: rem(405);
    height: rem(158);
    font-size: rem(22);
    color: #9B9B9B;
    line-height: 1.2;
    &-title{ 
      font-size: rem(30);
      color: #000;
      margin-bottom: rem(10);
      white-space: nowrap;
      overflow: hidden; 
      text-overflow:ellipsis;
      font-weight: 700;
    }
    &-desc {
      margin-bottom: rem(10);
    }
    &-m {
      margin-bottom: rem(10);
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        &:last-child {
          text-decoration: line-through;
        }
      }
    }
    &-info {
      color: #F5A623;
      line-height: rem(30);
    }
  }

}
</style>
